import { useLocalStorage } from '@vueuse/core'

const isNotesAppWidgetVisible = useLocalStorage('is_notes_app_widget_visible', false, {
  listenToStorageChanges: true,
  initOnMounted: true,
})

export default function useNotesApp() {
  return { isNotesAppWidgetVisible }
}
